<template>
  <div class="star-rating">
    <div
      v-for="i in maxStars"
      :key="i"
      @click="setRating(i)"
      @mouseover="hoverRating(i)"
      @mouseleave="resetHover"
      :class="['star', i <= (isHovered ? hoverValue : rating) ? 'filled' : '']"
    >
      ★
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    maxStars: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      rating: this.$props.value,
      isHovered: this.$props.value ? false : true,
      hoverValue: 0,
    };
  },

  methods: {

    setRating(newRating) {
      this.rating = newRating;
      this.isHovered = false;
      this.$emit('ratingData', newRating);
    },

    hoverRating(value) {
      if (this.isHovered) {
        this.hoverValue = value;
      }
    },

    resetHover() {
       this.hoverValue = 0;
    }
  
  },
};
</script>

<style scoped>
.star-rating {
  display: inline-block;
}

.star {
  display: inline-block;
  font-size: 36px;
  cursor: pointer;
  margin: 2px;
  color: rgb(222, 222, 222);
}

.filled {
  color: gold;
}
</style>